import { FusePageSimple } from "@fuse";
import _ from "@lodash";
import { Hidden, IconButton, withStyles } from "@material-ui/core";
import CatchErro from "app/Core/Components/CatchErro/CatchErro";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import withReducer from "app/store/withReducer";
import React from "react";
import { MdMenu } from "react-icons/md";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import PastaList from "../Arquivo/PastaList";
import * as Actions from "../Arquivo/Store/Actions/ArquivoActions";
import ArquivoReducer from "../Arquivo/Store/Reducers/ArquivoReducer";
import GaleriaList from "./GaleriaList";
import "react-image-gallery/styles/css/image-gallery.css";
import Visualizacao03 from "./Views/Visualizacao03";

const styles = theme => ({
    title: {
        color: theme.palette.type === "dark" ? "#FFFFFF" : "#000000"
    },
});

class GaleriaApp extends XAPPComponent {

    state = {
        conditions: null,
        pasta: "" + this.props.tipo,
        codigo: null,
        pastaclasse: null,
        pastanome: null,
        tipo: this.props.tipo,
    };

    componentDidMount() {
        const { showListagem = true, slideAll = false, xappRouteParams } = this.props;
        if (showListagem) {
            let AState = _.assign({}, this.state);
            if (slideAll) {
                AState.pasta = null;
            }
            this.props.list("SELECIONAR", xappRouteParams, AState, this.props.idfuncionalidade, { AND: [{ Campo: "mimetype", Operador: "LIKE", Valor: "image/%" }] });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { xappRouteParams } = this.props;
        if (!_.isEqual(prevState.pasta, this.state.pasta)) {
            this.props.list("SELECIONAR", xappRouteParams, this.state, this.props.idfuncionalidade, { AND: [{ Campo: "mimetype", Operador: "LIKE", Valor: "image/%" }] });
        }

    }

    componentWillUnmount() {
        this.props.clearArquivo();
    }

    setConditions = (_AValue) => {
        this.setState({ conditions: _AValue });
    };

    setPastaOld = () => {
        var APasta = this.state.pasta.split("/");
        APasta.splice(APasta.length - 1, 1);
        this.setPasta(APasta.join("/"));
    };

    setPasta = (_APasta) => {
        this.setState(_.set({ ...this.state }, "pasta", _APasta));
    };


    render() {
        const { multiSelect, onChange, tipo, slideAll = false, xappRouteParams } = this.props;
        return (
            <React.Fragment>
                <CatchErro
                    url={this.props.match.url}
                >
                    {!slideAll &&
                        <FusePageSimple
                            classes={{
                                header: "w-full flex",
                                sidebarHeader: "h-96 min-h-96 sm:h-160 sm:min-h-160",
                                //rightSidebar : "w-50"
                            }}
                            content={
                                <React.Fragment>
                                    {this.props.idfuncionalidade &&
                                        <div className="flex">
                                            <Hidden lgUp>
                                                <IconButton
                                                    onClick={() => this.pageLayout.toggleLeftSidebar()}
                                                    aria-label="open left sidebar"
                                                >
                                                    <MdMenu className="text-white" />
                                                </IconButton>
                                            </Hidden>
                                        </div>
                                    }
                                    <div className="flex justify-start flex-col p-16">
                                        <PastaList
                                            xappRouteParams={xappRouteParams}
                                            multiSelect={multiSelect}
                                            onChange={onChange}
                                            conditions={this.state.conditions}
                                            setPasta={this.setPasta}
                                            arquivoState={this.state}
                                            setPastaOld={this.setPastaOld}
                                            tipo={tipo}
                                        />
                                        <GaleriaList
                                            xappRouteParams={xappRouteParams}
                                            multiSelect={multiSelect}
                                            onChange={onChange}
                                            conditions={this.state.conditions}
                                            setPasta={this.setPasta}
                                            arquivoState={this.state}
                                        />
                                    </div>
                                </React.Fragment>
                            }
                            onRef={instance => {
                                this.pageLayout = instance;
                            }}
                            innerScroll
                        />
                    }
                    {slideAll &&
                        <Visualizacao03
                            slideAll={slideAll}
                            xappRouteParams={xappRouteParams}
                        />
                    }
                </CatchErro>
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getTags: Actions.getTags,
        getImage: Actions.getImage,
        list: Actions.list,
        clearArquivo: Actions.clearArquivo,
    }, dispatch);
}

function mapStateToProps({ Arquivo }) {
    return {
        Arquivo: Arquivo,
    };

}

export default withReducer("Arquivo", ArquivoReducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(GaleriaApp))));
